// toneFromId — deriva um tone de avatar (1..8) determinístico a partir de um id.
// O contrato do CRM não traz avatarTone do contato (só do owner), então geramos
// um tom estável por id pra cor do avatar não "piscar" entre renders/páginas.
import type { AvatarTone } from '@/components/ui/Avatar';

export function toneFromId(id: string): AvatarTone {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return ((Math.abs(hash) % 8) + 1) as AvatarTone;
}
